import { buildArrowHead } from "./arrow-components.js";
import { createLocalProjection } from "./local-projection.js";
import { clamp, leftNormal, magnitude, normalize, subtract, } from "./vector.js";
export function buildFineArrowFrame(tail, tipPosition, resolved) {
    const projection = createLocalProjection(tail);
    const tailCenter = { x: 0, y: 0 };
    const tip = projection.project(tipPosition);
    const directionVector = subtract(tip, tailCenter);
    const arrowLength = magnitude(directionVector);
    if (arrowLength < 1e-6) {
        throw new RangeError("A fine arrow requires two distinct control points.");
    }
    const direction = normalize(directionVector);
    const normal = leftNormal(direction);
    const tailHalfWidth = clamp(arrowLength * resolved.tailWidthRatio, resolved.minimumWidthMeters, resolved.maximumWidthMeters) / 2;
    const headLength = Math.min(arrowLength * resolved.headLengthRatio, arrowLength * 0.75);
    const head = buildArrowHead(tip, direction, {
        length: headLength,
        headHalfWidth: tailHalfWidth * resolved.headWidthRatio,
        neckHalfWidth: tailHalfWidth * resolved.neckWidthRatio,
    });
    return {
        projection,
        tailCenter,
        tip,
        direction,
        normal,
        arrowLength,
        tailHalfWidth,
        head,
    };
}
export function unprojectFineArrowRing(frame, ring, semanticTip, tipIndex) {
    const geographicRing = ring.map((point) => frame.projection.unproject(point));
    geographicRing[tipIndex] = [semanticTip[0], semanticTip[1]];
    return geographicRing;
}
//# sourceMappingURL=fine-arrow-frame.js.map